import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ParentLayout from './pages/parent/ParentLayout';
import Abonnements from './pages/parent/Abonnements';
import Enfants from './pages/parent/Enfants';
import EnfantLayout from './pages/enfant/EnfantLayout';
import Accueil from './pages/enfant/Accueil';
import Jeux from './pages/enfant/Jeux';
import Equipes from './pages/enfant/Equipes';
import Profil from './pages/enfant/Profil';
import MiroirEmotions from './pages/enfant/MiroirEmotions';
import AventureAmitie from './pages/enfant/AventureAmitie';

function ProtectedRoute({ children }) {
  const { token, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { token, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (token) {
    return <Navigate to="/app" replace />;
  }

  return children;
}

function RoleBasedLayout() {
  const { user } = useAuth();

  if (user?.role === 'parent') {
    return <ParentLayout />;
  }

  if (user?.role === 'enfant') {
    return <EnfantLayout />;
  }

  return <Navigate to="/" replace />;
}

function RoleBasedIndex() {
  const { user } = useAuth();

  if (user?.role === 'parent') {
    return <Abonnements />;
  }

  if (user?.role === 'enfant') {
    return <Accueil />;
  }

  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          } />
          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          <Route path="/register" element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          } />
          <Route path="/app" element={
            <ProtectedRoute>
              <RoleBasedLayout />
            </ProtectedRoute>
          }>
            <Route index element={<RoleBasedIndex />} />
            {/* Parent routes */}
            <Route path="enfants" element={<Enfants />} />
            {/* Enfant routes */}
            <Route path="jeux" element={<Jeux />} />
            <Route path="jeux/miroir-emotions" element={<MiroirEmotions />} />
            <Route path="jeux/aventure-amitie" element={<AventureAmitie />} />
            <Route path="equipes" element={<Equipes />} />
            <Route path="profil" element={<Profil />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
